module.exports = __webpack_public_path__ + "img/victron_30A.f5bcc218.png";